import { useState } from "react";

interface ShareButtonsProps {
  title: string;
}

export default function ShareButtons({ title }: ShareButtonsProps) {
  const [toast, setToast] = useState<string>("");
  const url = typeof window !== "undefined" ? window.location.href : "";

  const showToast = (message: string) => {
    setToast(message);
    window.setTimeout(() => setToast(""), 2500);
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      showToast("링크가 복사되었습니다.");
    } catch {
      showToast("복사에 실패했어요. 다시 시도해주세요.");
    }
  };

  const shareNative = async () => {
    if (typeof navigator !== "undefined" && navigator.share) {
      try {
        await navigator.share({ title, url });
      } catch {
        // 사용자가 공유를 취소한 경우 아무것도 하지 않습니다.
      }
    } else {
      await copyLink();
    }
  };

  const shareTwitter = () => {
    window.open(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`,
      "_blank",
      "noopener,noreferrer,width=600,height=420"
    );
  };

  const shareFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      "_blank",
      "noopener,noreferrer,width=600,height=420"
    );
  };

  const buttons = [
    { label: "카카오톡", icon: "ri-chat-3-line", onClick: shareNative },
    { label: "인스타그램", icon: "ri-instagram-line", onClick: shareNative },
    { label: "페이스북", icon: "ri-facebook-line", onClick: shareFacebook },
    { label: "X", icon: "ri-twitter-line", onClick: shareTwitter },
    { label: "링크 복사", icon: "ri-link", onClick: copyLink },
  ];

  return (
    <>
      <div className="flex flex-wrap items-center gap-2.5">
        {buttons.map((button) => (
          <button
            key={button.label}
            type="button"
            onClick={button.onClick}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-background-200 bg-white text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className={`${button.icon} text-base`}></i>
            {button.label}
          </button>
        ))}
      </div>

      {toast && (
        <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-50 px-5 py-3 rounded-full bg-foreground-900 text-white text-sm font-medium whitespace-nowrap">
          {toast}
        </div>
      )}
    </>
  );
}